import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  details: {
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 400,
    color: "#00A3A3",
  },
  searchBar: {
    display: "flex",
    height: "82px",
    backgroundColor: "#FAFBFC",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 10px",
  },
  searchField: {
    border: "1px solid lightgray",
    paddingLeft: "10px",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    borderRadius: "4px",
    "&.MuiInput-underline:before": {
      border: "none",
    },
  },
  searchTitle: {
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    color: "#A2A9BD",
  },
  highlightContainer: {
    padding: "10px",
  },
  highlightItem: {
    backgroundColor: "#FFECD6",
    borderRadius: "10px",
    height: "160px",
  },
}));
